module.exports = __webpack_public_path__ + "static/media/NSD_2.a8f247a2.jpg";